import React from 'react';

import { WorkspaceLayout } from '../../shared/components/Layout';

import styles from '../../shared/styles/_layout.module.scss';

const Settings = () => {
  return (
    <WorkspaceLayout>
      <h1 className={styles.dashboard__title}>Settings</h1>
    </WorkspaceLayout>
  );
};

export default Settings;
